import { Link } from "react-router-dom";
import NavLink from "./NavLink";

export default function TopBar() {
  return (
    <header className="fixed inset-x-0 top-0 z-50 h-16 border-b border-border-subtle bg-surface-raised/95 backdrop-blur-sm">
      <div className="mx-auto flex h-full max-w-7xl items-center gap-8 px-6">

        {/* Skip-to-content (screen readers / keyboard users) */}
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-primary focus:px-3 focus:py-1.5 focus:text-sm focus:font-medium focus:text-white focus:shadow-panel"
        >
          Skip to content
        </a>

        {/* Wordmark */}
        <Link
          to="/"
          className="flex shrink-0 items-center gap-2 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          aria-label="LegiSignal · DECAL — go to Today's Signals"
        >
          <span className="select-none text-sm font-semibold tracking-tight text-primary">
            LegiSignal
          </span>
          <span
            className="select-none rounded-sm bg-primary-light px-1.5 py-0.5 text-2xs font-semibold uppercase tracking-widest text-primary"
            aria-hidden
          >
            DECAL
          </span>
        </Link>

        {/* Primary nav */}
        <nav
          className="flex flex-1 items-center gap-1"
          aria-label="Primary navigation"
        >
          <NavLink to="/" end>
            Today's Signals
          </NavLink>
          <NavLink to="/bills">
            Bill Explorer
          </NavLink>
          <NavLink to="/knowledge">
            Knowledge Base
          </NavLink>
          <NavLink to="/about">
            About
          </NavLink>
        </nav>

      </div>
    </header>
  );
}
